
export const API_ENDPOINT = 'https://newconcept-group.com/korasaBackend';
// https://www.akfa-group.net/korasaBackend
export const API_ENDPOINT_Socket ='https://www.newconcept-group.com:2030'
